import { useQuery } from "@tanstack/react-query";
import { getUserStats } from "services/dashboard.service";

export const useUserDistribution = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["userStats", "distribution"],
    queryFn: getUserStats,
    select: (res) => {
      const stats = res?.data;
      if (!stats) return null;
      return {
        total: stats.totalUser ?? 0,
        total_formatted: (stats.totalUser ?? 0).toLocaleString(),
        distribution: (stats.distribution ?? []).map((item) => ({
          id: item.id,
          label: item.label,
          count: item.count,
          count_formatted: (item.count ?? 0).toLocaleString(),
          percent: item.percent,
        })),
      };
    },
  });

  return {
    distribution: data ?? null,
    isLoading,
    isError,
  };
};
